var fn = function( obj ){
var __t,__p='';
__p+='\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\n\nuniform mat4 uMVP;\nuniform vec4 uV4Model;\nuniform mat4 uProjection;\nuniform vec2 uScale;\n\nvarying vec2 vTexCoord;\n\nvoid main(void){\n\n  gl_Position = uProjection * ( uV4Model + vec4(aPosition * uScale, 0.0, 0.0) );\n\n  vTexCoord = aTexCoord;\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;